
export default {
    methods: {
        returnDateFormat(date, format='YYYY-MM-DD') {
            if(!date) {
                return '';
            }
            return this.$moment(date).format(format)
        },
        returnDateUnix(date, format='YYYY-MM-DD HH:mm') {
            if(!date) {
                return '';
            }
            return this.$moment.unix(date).locale('ko').format(format)
        },
        returnDateTime(date = null) {
            if (!date) {
                return '';
            }
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        },
        returnDateTimeStamp(date) { //데이트를 타임스탬프로 변환
            if (!date) {
                return '';
            }
            return this.$moment(date).format("x")
        },

        //입력한 날짜(day) 와 현재시간이 gapDays 일 이내의 차이가 날 경우 return true
        returnDifferenceDay(day,gapDays=0) {
            let date = this.$moment(day)
            let current = this.$moment()
            if(gapDays !== 0){
                gapDays = gapDays -1
                // date = this.$moment().add(gapDays,'days')
                current = this.$moment().add(-gapDays,'days')
            }


            let diff = current.diff(date, 'day')
            return diff <= 0
        },
    },
}
